import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { UserService } from 'src/app/services/user.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Router } from '@angular/router';
import jwt from 'jwt-decode' 
import {   MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import {UserModel} from 'src/app/models/user.model'
import {CompanyModel} from 'src/app/models/company.model'
import { PageEvent } from '@angular/material/paginator';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { DatePipe } from '@angular/common';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {SettingsService} from 'src/app/services/settings.service'
import { UserprofileService } from 'src/app/services/userprofile.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import * as XLSX from "xlsx";
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import * as ExcelJS from 'exceljs';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
export interface PeriodicElement {
  name: string;
  userName:string;
  sr: string;
  email: string;
  role: string;
  company:string;
}
export class companies{
  companyName?: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {sr: '', userName:'', name: '', email: '', role: '',company:''},

];
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UserComponent {
  @ViewChild('slideToggleUpdate') slideToggleUpdate!: MatSlideToggle;
  @ViewChild('slideToggleNotify') slideToggleNotify!: MatSlideToggle;
  @ViewChild('slideNotify') slideNotify!: MatSlideToggle;

  color = 'green';
  checked = false;
  disabled = false;
  totalElements:any
  isRoleChanged:boolean=false
  action:string="";
  groupList:any=[]
  tenantsList:any=[]
  isPasswordRequired:boolean=false;
  userRegFg! : FormGroup
  islisthide:boolean=true;
  nameControl = new FormControl('');
  Userlist: Array<UserModel> = [];
  data!:UserModel
  uploadDisable:boolean=false;
  Companylist:Array<any>=[];
  Rolelist:Array<any>=[];
  selectedRoles:Array<any>=[]
  selectedCompanies:Array<any>=[]
  showList:boolean=false;
  search:any={searchText:"",userType:"",status:"",mobile:"",branchId:''}
  userName:any
  fileSelected:boolean=false;
  selectedFile: any = null;
  invalidCredentialMsg:boolean
  //companies:Array<companies>
  private subs! : Subscription;
  loggedInUserType:any;
  createUserType:any;
  createUserStatus:any;
  updateUser:boolean=false;
  notifyUser:boolean=false;
  resMessage:any;
  loginUserType:any
  userType:any
  constructor(private DialogService:DialogService,private SettingsService:SettingsService,private fb : FormBuilder,private userService : UserService,private userinfoservice :UserInfoService,private AirManagementService:AirManagementService,
    private userProfileService:UserprofileService,
    private toastMsgService : ToastmsgService,
    private loginService : LoginService,
    private userinfo : UserInfoService,
    private router : Router,
    private customValidator : CustomValidatorsService,
    private userPrivileges: UserPrivilegeService,
    ) {
      this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
    this.userType = this.userinfoservice.getUserType()
    this.userType = this.userType.toUpperCase()
      this.branchList()
      

      this.getUsersList()
    this.Grouplist()
    this.tenantslist()
    this.data = {} as  UserModel;
   this.userName=""
   this.loggedInUserType=userinfoservice.getUserType();
   this.invalidCredentialMsg =false;
   this.subs = new Subscription();
   this.subs.add(
     this.userinfoservice.getUserInfoSubs().subscribe({next : (u : UserInfo) => {
       this.loggedInUserType=u.type;
     }})
   )
   this.userPrivileges.userPrivilegesByModule('Users').then((privileges:any) => {
    this.privilegesValue(privileges)
  })
  .catch((error:any) => {
  console.error(error); // Handle errors, if any
  });

  this.userPrivileges.userPrivilegesByModule('User-Role').then((privileges:any) => {
    this.privilegesRoles(privileges)
  })
  .catch((error:any) => {
  console.error(error); // Handle errors, if any
  });
 
  }
  ngOnInit(): void {
    this.dataFields()
  }
  dataFields(){
    this.userRegFg=this.fb.group({
      "email" :  ['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      "name" : ['',[Validators.required]],
      "userType":['STAFF',[Validators.required]],
      "mobile" : ['',[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      "groupCode":[null],
      "businessGroupCode":[null],
      "branchId":[''],
      "roleId":[[]],
      "whitelabelId":['0',[Validators.required]],
      "emailAllowed":false,
      "showTicketPricing":false,
    })
    
  }
  changeUserType(){
    if(this.userRegFg.value.userType==='STAFF'){
    
    this.userRegFg=this.fb.group({
      "email" :  [this.userRegFg.value.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      "name" : [this.userRegFg.value.name,[Validators.required]],
      "userType":[this.userRegFg.value.userType,[Validators.required]],
      "mobile" : [this.userRegFg.value.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      "groupCode":[null],
      "businessGroupCode":[null],
      "branchId":['',[Validators.required]],
      "roleId":[[]],
      "emailAllowed":false,
      "showTicketPricing":false,

      
    })}else if(this.userRegFg.value.userType==='CORPORATE'){
      this.userRegFg=this.fb.group({
        "email" :  [this.userRegFg.value.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
        "name" : [this.userRegFg.value.name,[Validators.required]],
        "userType":[this.userRegFg.value.userType,[Validators.required]],
        "mobile" : [this.userRegFg.value.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
        "groupCode":[null],
        "businessGroupCode":[null],
        "branchId":['',[Validators.required]],
        "roleId":[[]],
        "emailAllowed":this.userRegFg.value.emailAllowed,
        "showTicketPricing":this.userRegFg.value.showTicketPricing,
        

      })
    }else if(this.userRegFg.value.userType==='STAFF'){
      this.userRegFg=this.fb.group({
        "email" :  [this.userRegFg.value.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
        "name" : [this.userRegFg.value.name,[Validators.required]],
        "userType":[this.userRegFg.value.userType,[Validators.required]],
        "mobile" : [this.userRegFg.value.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
        "groupCode":[null],
        "businessGroupCode":[null],
        "branchId":[''],
        "roleId":[[]],
        "whitelabelId":['0',[Validators.required]],
        "emailAllowed":false,
        "showTicketPricing":false,

      })
    }else{
      
      this.userRegFg=this.fb.group({
        "email" :  [this.userRegFg.value.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
        "name" : [this.userRegFg.value.name,[Validators.required]],
        "userType":[this.userRegFg.value.userType,[Validators.required]],
        "mobile" : [this.userRegFg.value.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
        "groupCode":[null],
        "businessGroupCode":[null],
        "branchId":[''],
        "roleId":[[]],
        "emailAllowed":false,
        "showTicketPricing":false,

      })
    }
  }
  
  columnsToDisplay: string[] = ['id','type','name','email','creationDate','blank'];
  columnsToDisplayWithExpand = ['expand', ...this.columnsToDisplay];

  dataSource:any = [];
  expandedElement!: any | null;
  privilegesView:any
  privilegesRolesView:any
  privilegesRoles(privs:any){
    if(privs.includes('view')){
      this.privilegesRolesView="VAMD"
    }else{
      this.privilegesRolesView="AccessDenied"
    }
  }

  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

  onAddNew(){
    this.businessGrouplist()
    this.branchList()
    this.dataFields()
    if(this.userType==='CORPORATE'){
      this.getRoleTravellerList()
    }else{
      this.getRoleList()

    }
    this.action="New";
    this.isPasswordRequired=true;
    this.islisthide=false;
    this.data = {} as  UserModel;
    this.data.displayName ="";
    this.data.username="";
  }
 

compareCompanies(company1:any,company2:any):boolean{
  console.log(company1)
  console.log(company2)
  return company1 && company2 && company1===company2.companyCode;
}

compareRoles(role1:any,role2:any):boolean{
  console.log(role1)
  console.log(role2)
  return role1 && role2 && role1.id===role2.id;
}


  onBackbuttonClick(){
    this.islisthide=true;
    this.data = {} as  UserModel;
  }
  disablesave:boolean=false;
  notificationChecked:boolean=true
  registerUser() {
    if(this.userRegFg.value.userType==='CORPORATE'){
      if(this.userRegFg.value.groupCode===''){
      this.userRegFg.value.groupCode='0'}
      }else{
        this.userRegFg.value.groupCode=null
      }
      if(this.userRegFg.value.userType==='STAFF'){
        this.userRegFg.value.branchId=this.userRegFg.value.branchId.join(',')
      }
      // this.userRegFg.value.roleId=this.userRegFg.value.roleId?.join(',')

    this.disablesave=true
    this.userService.registerUser(this.userRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {

  if(this.slideNotify.checked){
let element={
  email:this.userRegFg.value.email
}
            this.resetPasswd(element)}
            this.toastMsgService.setMsg({msg : "User Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.islisthide=true;
           this.dataFields();
           
          } else {
            this.userRegFg.value.roleId=this.userRegFg.value.roleId.split(',')
            if(this.userRegFg.value.userType==='STAFF'){

            this.userRegFg.value.branchId=this.userRegFg.value.branchId.split(',')
            }
            const body : any = res.body;
            this.registerUserErrorMsg(res.status,body?.result);
          } 
          this.disablesave=false

        },error : (err) => {
          if(this.userRegFg.value.userType==='STAFF'){
            this.userRegFg.value.branchId=this.userRegFg.value.branchId.split(',')
          }
          this.userRegFg.value.roleId=this.userRegFg.value.roleId.split(',')

          this.disablesave=false

          this.registerUserErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUserErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save User",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save User",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  confirmPasswordValidator = (): ValidatorFn => {

    return (control : AbstractControl) : ValidationErrors|null => {
      if(!control.value) {
        return {
          invalidMsg: "Please enter confirm password!"
        };
      }
      const passwordControl=this.userRegFg.controls['password'];
      if(passwordControl.value !=control.value) {
        return {
          invalidMsg: "password mismatch!"
        };
      } else {
        return null;
      }
    };
  }

  getControlErrMsg(control : AbstractControl) {
    return control?.errors?.['invalidMsg']
  }
  openPopup() {
    this.islisthide=false;
  }
  closePopup() {
    this.islisthide=true;
  
  }
  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
   
    this.getAllUser(page)
  
  }
  searchTimeout:any
  searchUser(event:any,type:any){

    console.log(event)
    if(type==='input'){

    this.search.searchText=event.target.value

    }else if(type==='button'){
      this.search.searchText=event.username ||''

    }
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getAllUser({ page: this.pagestr.number, size: this.pagestr.size });
    }, 300);
    // this.getAllUser({page: this.pagestr.number, size: this.pagestr.size,})
    this.userName=""

  }
  pagestr:any={
    number:'0',
    size:'10'
  }
  getAllUser(page:any){

    this.userService
    .getAllUser(page,this.search)
    .subscribe({
      
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }
         // this.Userlist=data.result.content;
         
          this.dataSource=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.dataSource.length>0){
          this.showList=true
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

        console.error("Error in fetching all getAllUsers");
      }
    }
  )
  }

  verifyEmail:boolean=false
  verifiedEmail(){
    let request
    console.log(this.userRegFg.value.email);
if(this.userRegFg.value.email)
{request=this.userRegFg.value.email;

   
    this.userService
    .verifyEmail(request)
    .subscribe({
      next : (res:any) => {
        this.disablesave=false
        this.verifyEmail=false
      },error : (err) => {
        this.disablesave=true
        this.verifyEmail=true

      }
    }
  )}
  }
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }
  UpdateUser(element:any){
    // window.location.href = "/app/User?email="+this.transformEmail(element)
window.open("/app/User?email="+this.transformEmail(element))
   //this.router.navigate(['/app/User'], { queryParams:  element });    
  }
  transformEmail(email: string): string {
    let result = '';
  
    for (let i = 0; i < email.length; i++) {
      const char = email.charCodeAt(i);
      result += char.toString(16); // Convert the character code to a hexadecimal string
    }
  
    return result;
  }
  EmulateUser(element:any){
  //  console.log(element)
   // window.location.href = "/app/flight?name="+this.transformEmail(element)
    //this.router.navigate(['/app/flight'], { queryParams:  element });   
    const request = {username:element.username,action:"emulate"}
    this.loginService.regenerate(request)
    .subscribe({next : (res:any)=> {
      console.log(res)
      if(res) { 
       if(res.token) {
        let parentUser=undefined;
        if(res.parentUser){
          parentUser = res.parentUser
        }
        this.userinfo.setToken(res.token);
        window.location.href="/app/flight"
      //  this.router.navigate(["/app/flight"]);
       // const userData:any = jwt(body["token"]);
      
      }
      } else {
        this.loginErrorResponseStatus(res);
      }
  }, error : (err:any)=> {
    this.loginErrorResponseStatus(err);
  }})
}


payment_Contract(item:any){
  this.router.navigate(["/app/payment-contract/"+item.userUid]);

}


loginErrorResponseStatus(res : any) {
  if(res.status==401) {
    this.invalidCredentialMsg=true;
  } 
}
 

  
  backClick(){
    
    this.router.navigate(["/app/settings"]);
  }
  isexcelUpload = false;

  openExcelAdd() {
    this.selectedFile=null
    if(this.loggedInUserType==="Staff"){
      this.createUserType="CORPORATE"
      }
      if(this.loggedInUserType==="Corporate"){
       this.createUserType="EMPLOYEE"
       }
       this.createUserStatus = "ENABLE";
    this.isexcelUpload = true;
  }

  closeExcelAdd() {
    this.isexcelUpload = false;
  }

  downloadSample() {
    let file = "";
    if(this.loggedInUserType==='Corporate' ){
      file =  "assets/images/sampleFiles/TravellerUploadSample.xls";
    }
    if(this.loggedInUserType==='Staff'){
      file =  "assets/images/sampleFiles/CorporateUploadSample.xls";
    }
    
    let link = document.createElement("a");
    link.download = "UserUploadSample.xls";
    link.href = file;
    link.click();
  }

  uploadUserExcelFile() {

    this.uploadDisable=true;

    const request = {userType:this.createUserType,userStatus:this.createUserStatus,userAlertConfig:this.slideToggleNotify.checked,updateUser:this.slideToggleUpdate.checked}
    this.userService.uploadUserExcel(this.selectedFile,request).subscribe({next : (res:any)=> {
      console.log(res)
      if(res.message==='Request Submitted Successfully') { 
        

        this.uploadDisable=false;

        this.toastMsgService.setMsg({msg : "Upload user successfully",msgTitle : "Success", msgType : "I"});
        this.selectedFile=null
        this.isexcelUpload = false;
        this.DialogService.open({msg :'View Upload Status',title : "Information",buttonType : "OkCancel"})
       
        this.DialogService.onResponse((response :  string) => {
         
          if(response=="Ok") {
            this.router.navigate(["/app/manage-file-upload"]);   
                 }})
        
      } else {
        this.uploadDisable=false;


        this.toastMsgService.setMsg({msg : "Failed to Upload",msgTitle : "Warning", msgType : "W"});

        this.loginErrorResponseStatus(res);
        this.selectedFile=null



       
      }
  }, error : (err:any)=> {
    this.uploadDisable=false;

    // this.uploadDisable=false;
    this.toastMsgService.setMsg({msg : "Failed to Upload",msgTitle : "Warning", msgType : "W"});

    this.loginErrorResponseStatus(err);
  }})
    // Handle the uploaded file here.
    // You can access the selected file using this.fileInput.nativeElement.files[0].
    
  }


onFileSelected(event: any): void {
  console.log(event)
  this.fileSelected=true;
    // this.selectedFile = event.target.files[0] ?? null;
    this.selectedFile = event.files[0] ?? null;


}
onConfigClick(uuid:any){
  window.location.href="/app/config?id="+this.SettingsService.transform(uuid)
}
onCommercialClick(uuid:any){
  window.location.href="/app/commercials?id="+this.SettingsService.transform(uuid)

}


onBalanceClick(uuid:any){
  window.location.href="/app/payment-config?id="+this.SettingsService.transform(uuid)+"&type="+this.SettingsService.transform('c')

}
Grouplist(){

  this.AirManagementService
  .grouplist()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.groupList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
tenantslist(){

  this.AirManagementService
  .tenantlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.tenantsList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}




    suggestions: any[] = [];
    filteredUser: any[] = [];;

    searchList(event: AutoCompleteCompleteEvent) {
      let filtered: any[] = [];
        let query = event.query;
// console.log(event.originalEvent)
        for (let i = 0; i < (this.suggestions as any[]).length; i++) {
            let user = (this.suggestions as any[])[i];
            if (user.name.toLowerCase().trim().indexOf(query.toLowerCase().trim()) == 0) {
                filtered.push(user);
            }
        }

        this.filteredUser = filtered;
        // console.log(filtered)
    }
    userlist:any=[]
    getUsersList(){
    let userType:any
      userType=this.loggedInUserType
        this.userService.getUserList(userType)
        .subscribe({
          next : (res:any) => {
            if(res) {
             // console.log(res)
            let  data:any;
            data=res["result"]
            this.suggestions=data
            // for (let i = 0; i < data.length; i++) {
              
            //   this.whereTo.push(data[i]?.name);
  
            // }
     
          }else{
  
          }},error : (err) => {
      
            console.error("Error in fetching data");
          }
        }
      )
      
    }



    updateUserInfo(item:any) {
      let status:any
     let msg:any
if(item.status==='ENABLE'){
  status='DISABLE'
  msg='Are you sure you want to disable the user?'
}else if(item.status==='DISABLE'){
  status='ENABLE'
  msg='Are you sure you want to Enable the user?'

}

     let request:any={
        "name" :item?.name,
        "email" :  item.email,
        "mobile" : item?.mobile,
        "status":status,
        "accountCode":item?.accountCode,
        "branchId":item?.branchId,
           "roleId":item?.roleId,
       
      }

      this.DialogService.open({msg : msg,title : "Confirmation",buttonType : "YesNo"})
       
      this.DialogService.onResponse((response :  string) => {
       
        if(response=="Yes") {
        
      this.userService.updateUserInfo(request,item.email)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
              this.getAllUser({page: this.pagestr.number, size: this.pagestr.size,})
            } else {
              // const body : any = res.body;
              // this.registerUserErrorMsg(res.status,body?.result);
              this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});

            } 
    
          },error : (err) => {
            this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});

            // this.registerUserErrorMsg(err.status,err.error);
          }
        }
      )
    }})
    }


    roleList:any=[]
    getRoleList(){
      this.userService
      .getRoleList()
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res
           this.roleList=data.result
           
           } else {
  
           } 
        },error : (err) => {
  
          console.error("Error in fetching all getRoleList");
        }
      }
    )
    }
    getRoleTravellerList(){
      this.userService
      .getRoleTravellerList()
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res
           this.roleList=data.result
           
           } else {
  
           } 
        },error : (err) => {
  
          console.error("Error in fetching all getRoleList");
        }
      }
    )
    }
    

    resetPasswd(element:any){
      this.loginService.getPasswordLink(element.email)
      .subscribe({next : (res)=> {
        
        let data:any={message:"",success:""}
         data = res
         if(data.message==="Mail send successfully"){
          // this.show=false
          this.toastMsgService.setMsg({msg : "Password reset link sent successfully",msgTitle : "Success",msgType : "I"});
  
         }else{
          this.toastMsgService.setMsg({msg : data.message,msgTitle : "Warning", msgType : "W"});
  
         }
  
      },error : (err) => {
        
        this.toastMsgService.setMsg({msg : "Failed to Send",msgTitle : "Warning", msgType : "W"});
  
        }})
    }




    updateDUserInfo(item:any) {

      let status:any
      let msg:any
      if(item.status==='DEACTIVATED'){
        status='ENABLE'
        msg='Are you sure you want to Activate the user?'

      }else if(item.status==='ENABLE'||item.status==='DISABLE'){
        status='DEACTIVATED'
        msg='Are you sure you want to Deactivate the user?'

      }

      
      let request:any={
         "name" :item?.name,
         "email" :  item.email,
         "mobile" : item?.mobile,
         "status":status,
         "accountCode":item?.accountCode,    
           "branchId":item?.branchId,
           "roleId":item?.roleId,


       }
      
       this.DialogService.open({msg : msg,title : "Confirmation",buttonType : "YesNo"})
        
       this.DialogService.onResponse((response :  string) => {
        
         if(response=="Yes") {
         
       this.userService.updateUserInfo(request,item.email)
         .subscribe({
           next : (res) => {
             if(res.status==200 || res.status==201) {
               this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
               this.getAllUser({page: this.pagestr.number, size: this.pagestr.size,})
             } else {
               // const body : any = res.body;
               // this.registerUserErrorMsg(res.status,body?.result);
               this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});
 
             } 
     
           },error : (err) => {
             this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});
 
             // this.registerUserErrorMsg(err.status,err.error);
           }
         }
       )
     }})
     }
     branchData:any=[]
     disableResync:boolean=false
     synctickets(){
      this.disableResync=true
      this.userService
      .synctickets()
      .subscribe({
        next : (res:any) => {
          this.disableResync=false
          if(res) {

          this.DialogService.open({msg : res.msg1,title : "Confirmation",buttonType : "Ok"})
        
          this.DialogService.onResponse((response :  string) => {
           
            if(response=="Ok") {


            }})


          // this.toastMsgService.setMsg({msg : "Resync Successfully!",msgTitle : "Success", msgType : "I"});

            
           } else {
            this.toastMsgService.setMsg({msg : "Failed to Resync",msgTitle : "Warning", msgType : "W"});

           } 
        },error : (err) => {
          this.disableResync=false
          this.toastMsgService.setMsg({msg : "Failed to Resync",msgTitle : "Warning", msgType : "W"});

        }
      }
    )
     }
     branchList(){

      this.AirManagementService
      .branchlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         this.branchData=res
       
          } else {
          
          } 
        },error : (err) => {
    
        }
      }
    )
    }
    showSearchList(){
      this.showList=false

    }
    showSearch(){

      this.showList=true

    }
    onlyNumberKey(event:any) {
     
      let charCode = (event.which) ? event.which : event.keyCode;
      if (charCode != 46 && charCode > 31
          && (charCode < 48 || charCode > 57))
          return false;
      return true;
    }
    userExcel:any
    exportDatas(){

     let  curdatestring:Date=new Date()
    // let  exportData:any=JSON.parse(this.userExcel)

    const dataWithUppercaseHeaders = this.dataSource.map((item: any) => {
      const transformedItem: any = {};
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          transformedItem[key.toUpperCase()] = item[key];
        }
      }
      return transformedItem;
    });
    
    // Convert the modified data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(dataWithUppercaseHeaders);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
    // Write the workbook to a file
    XLSX.writeFile(workbook, "Users" + curdatestring + ".xlsx");
     }
     businessGroupList:any=[]
     businessGrouplist(){

      this.AirManagementService
      .businessGrouplist()
      .subscribe({
        next : (res:any) => {
          if(res) {
            let data=res
         this.businessGroupList=data
         this.filterBusinessEntities()
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }

    searchBusinessQuery:any=""

filteredBusinessGroup: any[] = [...this.businessGroupList]; // Clone the original data

// Function to filter the entities based on the search query
filterBusinessEntities() {

  this.filteredBusinessGroup= this.businessGroupList.filter((item:any) =>
    item.name.toLowerCase().trim().includes(this.searchBusinessQuery.toLowerCase().trim())
  );

  
}
exportData() {
  let  curdatestring:Date=new Date()

  const headersKeys = [
    'userUid',
    'name',
    'status',
    'mobile',
    'email',
    'branchId',
    'accountCode',
    'userType',
    'username',
    'creationDate',
  
  ];
  function branchFilter(branchCode:any,branchData:any){
    let ite:any=[]
  if(ite){
    ite=  branchData.filter((branch:any)=>branch.branchCode===branchCode)

  if(ite.length!=0){
    return ite[0]?.city||''
  } return ''}
  return ''
  }
  let mappedData: any = []
  mappedData = this.dataSource.map((item: any) => {
    let filteredItem: any = {};
    headersKeys.forEach(key => {
      if (key === 'creationDate' && item[key]) {
        const date = this.formatDate(item[key]);
        filteredItem[key] = date; // format: DD/MM/YYYY
      } else if(key === 'branchId' && item[key]){
        const date = branchFilter(item[key],this.branchData)
        filteredItem[key] = date; 
      }
      else {
        filteredItem[key] = item[key] ?? null;
      }
    });
    return filteredItem;
  });
  console.log(mappedData)

  // Create a new workbook and add a worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Flight Data');

  // Apply header styles
  this.applyHeaderStyles(worksheet,mappedData);

  // Add the mapped data to the worksheet
  mappedData.forEach((item: any) => {
    worksheet.addRow(item);
  });

  // Save workbook to a file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download =  "Users_" + this.formatDate(curdatestring) + ".xlsx";
    link.click();
  });
}
// applyHeaderStyles(worksheet: ExcelJS.Worksheet): void {
//   // Define the headers
//   worksheet.columns = [
//     { header: 'Bid#', key: 'Bid#', width: 15 },
//     { header: 'Carrier Name', key: 'Carrier Name', width: 20 },
//     { header: 'Flight Number', key: 'Flight Number', width: 20 },
//     { header: 'From Airport', key: 'From Airport', width: 20 },
//     { header: 'To Airport', key: 'To Airport', width: 20 },
//     { header: 'Scheduled Departure', key: 'Scheduled Departure', width: 25 },
//     { header: 'Scheduled Arrival', key: 'Scheduled Arrival', width: 25 },
//     { header: 'Travel Duration', key: 'Travel Duration', width: 20 },
//     // { header: 'Base Fare', key: 'Base Fare', width: 15 },
//     { header: 'Ticket Cost', key: 'Ticket Cost', width: 15 },
//     { header: 'Fare Type', key: 'Fare Type', width: 20 },
//     { header: 'Refundable', key: 'Refundable', width: 15 },
//     { header: 'Meal Included', key: 'Meal Included', width: 15 }
//   ];
// }
applyHeaderStyles(worksheet: ExcelJS.Worksheet, data: any[]): void {
  if (!data || data.length === 0) {
    return;
  }

  // Get keys from the first object in the data array
  // const headers = Object.keys(data[0]);

  // // Set worksheet columns dynamically with same width
  // worksheet.columns = headers.map(key => ({
  //   header: key,
  //   key: key,
  //   width: 20 // You can make this dynamic too if needed
  // }));
  // if (!data || data.length === 0) {
  //   return;
  // }
  

  // Get dynamic headers from data keys

  // Set columns with headers and default width
  // worksheet.columns = headers.map(key => ({
  //   header: key.toUpperCase(),
  //   key: key,
  //   width: 20
  // }));

  const headers = [
    'userUid',
    'name',
    'status',
    'mobile',
    'email',
    'branchId',
    'accountCode',
    'userType',
    'username',
    'creationDate',
  
  ];
  worksheet.columns = [
    { header: 'User Uid', key: 'userUid', width: 20 },
    { header: 'Name', key: 'name', width: 35 },
    { header: 'Status', key: 'status', width: 20 },
    { header: 'Mobile', key: 'mobile', width: 20 },
    { header: 'Email', key: 'email', width: 35 },
    { header: 'Username', key: 'username', width: 35 },
    { header: 'Branch', key: 'branchId', width: 20 },
    { header: 'Account Code', key: 'accountCode', width: 20 },
    { header: 'User Type', key: 'userType', width: 20 },
    { header: 'Creation Date', key: 'creationDate', width: 35 },

  ];
  // worksheet.columns = headers.map(key => ({
  //   header: key.toUpperCase(),
  //   key: key,
  //   width: 20
  // }));


  
  //  Map headers to worksheet.columns and apply uniform width
  // worksheet.columns = headers.map(header => ({
  //   header,
  //   key: header,
  //   width: 25 // set your desired width here
  // }));

  // Apply styles to the header row (row 1)
  const headerRow = worksheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // white text
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '4472C4' } // dark blue background (you can change it)
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // Optional: Adjust row height
  headerRow.height = 25;

  headerRow.commit(); // Commit changes to the row
  

}


}
